<template>
  <div class="multiplier-speed-box show-flex-box-r" @click.stop="closeFloat()">
    <div :class="{'show-flex-box-r':true,'show-status': showFloatStatus}">
      <ul class="box-scrollbar-hidden">
        <li v-for="(item,index) in multipleList"
            :key="index"
            :class="{'show-flex-box-r show-flex-center':true,'current-selected-status': currentMultiple == item.multiple}"
            @click.stop="selectedMultiple(item)">
          <span>{{item.name}}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    isShow: [Boolean],
    multiple: [String,Number],
  },
  components: {

  },
  data(){
    return {
      multipleList: [
        {buttonType: 'selectedMultiple',multiple: 0.75,name: '0.75X'},
        {buttonType: 'selectedMultiple',multiple: 1,name: '1.0X'},
        {buttonType: 'selectedMultiple',multiple: 1.25,name: '1.25X'},
        {buttonType: 'selectedMultiple',multiple: 1.5,name: '1.5X'},
        {buttonType: 'selectedMultiple',multiple: 2,name: '2.0X'}
      ],
      showFloatStatus: false,
      currentMultiple: 1,
    }
  },
  watch: {
    isShow: function() {
      this.setShowFloatStatus();
    },
  },
  mounted() {
    
  },
  methods: {
    setShowFloatStatus: function() {
      const times = this.isShow ? 0 : 300;
      
      setTimeout(()=>{
        this.setFloatStatus(this.isShow);
      },times)
    },
    setFloatStatus: function(isShow) {
      this.showFloatStatus = typeof(isShow) != 'undefined' ? isShow : !this.showFloatStatus;
    },
    selectedMultiple: function(chooseData) {
      this.currentMultiple = chooseData.multiple;
      this.sendClickInfo(chooseData);
      this.closeFloat();
    },
    closeFloat: function() {
      this.setFloatStatus(false);
      
      this.sendClickInfo({
        buttonType: 'closeMultiple',
      })
    },
    sendClickInfo: function(clickInfo) {
      this.$emit('clickInfo',clickInfo);
    }
  },
};
</script>

<style lang="less">
  .multiplier-speed-box {
    width: 100%;
    height: 100%;
    justify-content: flex-end;
    &>div {
      width: 1.5rem;
      align-items: center;
      border-top-left-radius: 0.1rem;
      border-bottom-left-radius: 0.1rem;
      transform: translateX(100%);
      transition: all 0.3s ease;
      background: rgba(0,0,0,0.8);
      &>ul { 
        width: 100%;
        overflow-y: scroll;
        max-height: 1.5rem;
        &>li {
          height: 0.3rem;
          &>span {
            display: block;
            font-size: 0.14rem;
            color: #fff;
          }
        }
        &>li.current-selected-status {
          &>span {
            color: #86C730;
          }
        }
        &>li:active {
          background: rgba(0,0,0,0.9);
          &>span {
            color: #86C730;
          }
        }
      }
    }
    &>.show-status {
      transform: translateX(0);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/video_player/child/multiplier_speed_float.vue